// {
//     "Journey Name": "evar4",
//     "Session Id": "evar5",
//     "Journey Id": "evar6",
//     "Outbound Channel": "evar7",
//     "Inbound Channel": "evar8",
//     "Source Page URL": "evar9",
//     "IP Address": "evar10",
//     "Referer": "evar11",
//     "Page Name": "evar12",
//     "Shortcode": "evar13",
//     "Card Type": "evar14",
//     "Account No": "evar15",
//     "Old Card last 4 digits": "evar16",
//     "New card last 4 digits": "evar17",
//     "Mobile Number": "evar18",
//     "PAN": "evar19",
//     "DOB": "evar20",
//     "Prospect ID": "evar21",
//     "Email Id": "evar22",
//     "Application Number": "evar23",
//     "Service Request Number": "evar24",
//     "Status": "evar25",
//     "Error Code": "evar26",
//     "Error Description": "evar27",
//     "Decision Code": "evar28",
//     "Decision Reason": "evar29",
//     "Amount": "evar30",
//     "OTP Resend": "evar31",
//     "First Name": "evar32",
//     "Last Name": "evar33",
//     "City/DigiMOD Screen": "evar34",
//     "Pincode": "evar35",
//     "Facebook ID": "evar36",
//     "Twitter ID": "evar37",
//     "LinkedIn ID": "evar38",
//     "Middle Name": "evar39",
//     "Gem ID1": "evar40",
//     "Gem ID2": "evar41",
//     "state": "evar42",
//     "Lead Reference Number": "evar43",
//     "Lead State" : "evar44",
//     "Lead State Description": "evar45"
// }
import store from '../store';
import { findFromObject } from "../shared/utility";
import GlobalService from "../services/GlobalService";
import { isPartnerChannelCode } from "../shared/PartnerUtility";

const sourcePageUrl = () => window.location.href;

const getReferer = () => document.referrer;

const getJourneyID = () => {
        //const state = store.getState();
        //const accessToken = findFromObject(state, 'User.UserDetail.oauth.accessToken')
        const accessToken = GlobalService?.oauth?.accessToken;
        return accessToken ? accessToken : "";
}

const getSessionId = () => {
        const state = store.getState();
        const shortCode = findFromObject(state, 'User.UserDetail.shortCode')
        const accessToken = GlobalService?.oauth?.accessToken;
        return shortCode ? shortCode : accessToken;
}

const getIpAddress = () => {
        const clientIPAddress = GlobalService?.oauth?.clientIPAddress;
        return clientIPAddress ? clientIPAddress : "";
}
const getOutboundChannel = () => {
        return localStorage.getItem("obcCode");
}

const getLeadSourceCode = () => {
        return localStorage.getItem("sourceCode");
}
    
const getLeadChannel = () => {
        return localStorage.getItem("chnCode");
}
    
const getGEMID1 = () => {
        return localStorage.getItem("gemId1");
}

const getGEMID2 = () => {
        return localStorage.getItem("gemId2");
}

const getShortCode = () => {
        const state = store.getState();
        return state.User?.UserDetail?.shortCode || localStorage.getItem("shortCode")
}

const getApplicationnumber = () => {
        const state = store.getState();
        return state.SSL?.ckycData?.applicationNumber || localStorage.getItem("applicationNumber")
}

const getAddressType = () => {
        const state = store.getState();
        const digiData = state.DigiLocker?.digiLockerData;
        return  digiData?.address?.[0]?.addressSplitStatus===false ? "DIGIMOD" : "" ;
}

//const getNullValueInEvar34 = () => ''

const getPincode = () => {
        const state = store.getState();
        const channelCode = state.User.UserDetail.channelCode;
        return isPartnerChannelCode(channelCode) ? state.User.UserDetail?.resiAddr[0]?.pin : state.User.UserDetail?.resiAddr?.pin;
}
const getVkycOptFlag = () => {
        const state = store.getState();
        const vkycOptFlg = state.MidMitc.vkycData.vkycOptFlag;
        return vkycOptFlg === "Y" ? "VKYC" : "Penny drop"; 
}
const getNetworkName = () => {
        const state = store.getState();
        return state.User?.UserDetail?.currentNwType ? state.User?.UserDetail?.currentNwType : state.AppState.cardListDetails.networkName;
}
const getNetworkPriority = () => {
        const state = store.getState();
        return state.User?.UserDetail?.priority ? state.User?.UserDetail?.priority : 1;
}
const getCurrentCardType = () => {
        const state = store.getState();
        return  (state.User?.UserDetail?.isNwChanged==="Y" && state.User?.UserDetail?.selCurrCardType) ? state.User?.UserDetail?.selCurrCardType : state.User?.UserDetail?.cardType ? state.User?.UserDetail?.cardType : state.AppState.cardListDetails.cardType;
}

const getCurrentProductName = () => {
       const state = store.getState();
       return state.AppState.cardListDetails.productType;
}

const getCurrentProductType = () => {
       const state = store.getState();
       return state.AppState.cardListDetails.uniqueIdentifier;
}

const getFfnNo = () => {
        const state = store.getState();
        return state.IndigoFFN.IndigoFFNNo ? state.IndigoFFN.IndigoFFNNo : state.User?.UserDetail?.ffnNo;
}

export const mandatoryFields = ["evar1", "evar2", "evar3", "evar4", "evar8", "evar31", "evar44", "evar45"];

export const eventValueMap = {
        "evar5": getSessionId,
        "evar6": getJourneyID,
        "evar7": getOutboundChannel,
        "evar9": sourcePageUrl,
        "evar10": getIpAddress,
        "evar11": getReferer,
        "evar12": 'AppState.screenName',
        "evar13": getShortCode,
        "evar14": getCurrentCardType,
        "evar15": getFfnNo,
	"evar17": getNetworkName, // added for change new        
        "evar18": 'User.UserDetail.mobileNo',
        "evar19": 'User.UserDetail.panNumber',
        "evar20": 'User.UserDetail.dob',
    	"evar21": getNetworkPriority, // added for change new       
        "evar22": 'User.UserDetail.emailId',
        "evar23": getApplicationnumber,
        "evar24": getCurrentProductName, // added for change new 
        "evar32": 'User.UserDetail.firstName',
        "evar33": 'User.UserDetail.lastName',
        "evar34": getAddressType, //'User.UserDetail.resiCity',//'User.UserDetail.resiAddr.city',
        "evar35": getPincode,
        "evar37": getVkycOptFlag,
        "evar39": 'User.UserDetail.middleName',
        "evar40":  getGEMID1,
        "evar41":  getGEMID2,
        "evar42": 'User.UserDetail.resiAddr.state',
        "evar43": 'User.UserDetail.leadRefNo',
        "evar46": getLeadSourceCode,
        "evar47": getLeadChannel,
        "evar48": getCurrentProductType,
        "evar49": 'User.UserDetail.channelCode',
        "evar50": 'User.UserDetail.leadSource',
}

const trackingObj = {
        "tracking_1": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar18", "evar19", "evar20","evar21", "evar22", "evar23","evar24", "evar32", "evar33", "evar39", "evar40", "evar41"],
                "Action description 2": "user clicks on the link which is received on SMS/Email",
                "Event Name": "event1",
                "evar1": "login_intent",
                "evar2": "c2b",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_2": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar18", "evar19", "evar20","evar21", "evar22", "evar23","evar24", "evar32", "evar33", "evar39", "evar40", "evar41"],
                "Action description 2": "sbicard system receive the request to resolve the shortcode",
                "Event Name": "event2",
                "evar1": "login_1f_intent",
                "evar2": "c2b",
                "evar3": "shortcode",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_3": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar18", "evar19", "evar20","evar21", "evar22", "evar23","evar24", "evar32", "evar33", "evar39", "evar40", "evar41"],
                "Action description 2": "shortcode gets resolved and user successfully landed on SBICard website",
                "Event Name": "event3",
                "evar1": "login_1f_auth",
                "evar2": "c2b",
                "evar3": "shortcode:valid/invalid/expired",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_4": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14","evar17", "evar18", "evar19", "evar20", "evar21", "evar22", "evar23","evar24", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When user lands on STP landing page by clinking on apply now button in eapply cards catalog page",
                "Event Name": "event20",
                "evar1": "page_load",
                "evar2": "stp_landing",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_5": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When user clicks on \"continue to apply card\" button on stp landing page",
                "Event Name": "event28",
                "evar1": "click_link",
                "evar2": "continue_to_apply_card",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_6": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When user clicks on \"view benifits\" button on stp landing page",
                "Event Name": "event28",
                "evar1": "click_link",
                "evar2": "view_benifits",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_7": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When user clicks on \"Change Card\" button on stp landing page",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_change_card",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_8": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When user clicks on \"proceed\" button on pop-up of change card confirmation",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_change_card",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_9": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When user clicks on \"cancel\" button on pop-up of change card confirmation",
                "Event Name": "event11",
                "evar1": "form_abandonment",
                "evar2": "stp_change_card",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_10": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When user clicks on \"Retrieve my application\" button on stp landing page",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "retrieve_my_application",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_11": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user clicks on the arrow on personal details box",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_form",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_12": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user clicks on the arrow on personal details box",
                "Event Name": "event34",
                "evar1": "journey_milestone",
                "evar2": "stp",
                "evar3": "journey_started",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_13": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": 'When screen gets loaded for "First name, middle name, last name and Mobile number"',//"When user clicks apply now button to apply for that particular card",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_peronal_details",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_14": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when generate OTP screen gets loaded",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_personal_details_generate_otp",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_15": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar25", "evar26", "evar27", "evar31", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "User clicks on Continue to get OTP",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_personal_details_generate_otp",
                "evar4": "stp",
                "evar8": 'website',
                "evar31": "N"
        },
        "tracking_16": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar25", "evar26", "evar27", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "Once otp is generated and next screen gets loaded",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_personal_details_generate_otp",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_17": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when verify otp screen gets loaded",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_peronal_details_verify_otp",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_18": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar25", "evar26", "evar27", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user submit the OTP",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_peronal_details_verify_otp",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_19": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar25", "evar26", "evar27", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "Once otp is verified",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_peronal_details_verify_otp",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_19_penny": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar25", "evar26", "evar27", "evar32", "evar33", "evar39", "evar40", "evar41"],
                "Action description 2": "User is moved to the next page from penny drop",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_bank_verification_credit",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_20": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar25", "evar26", "evar27", "evar31", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar46", "evar47"],
                "Action description 2": "When user submits the otp and submit the form to retrieve the last filled application",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "retrieve_my_application",
                "evar4": "stp",
                "evar8": 'website',
                "evar31": "Y"
        },
        "tracking_21": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar25", "evar26", "evar27", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "Once user have retrieve the application",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "retrieve_my_application",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_22": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When user click on on the Edit button to edit the personal details he has submitted",
                "Event Name": "event16",
                "evar1": "form_edit",
                "evar2": "stp_peronal_details",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_23": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar50"],
                "Action description 2": "SSL Creation on Verification of OTP",
                "Event Name": "event34",
                "evar1": "journey_milestone",
                "evar2": "stp",
                "evar3": "lead_created",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "SSL Created (OTP validated)",
                "evar45": "Name Mobile and OTP given"
        },
        "tracking_24": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When demog call gets initiated",
                "Event Name": "event32",
                "evar1": "3p_redirection_initiate",
                "evar2": "stp_peronal_details_demog",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_25": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar46", "evar47"],
                "Action description 2": "When response from the demog call is received",
                "Event Name": "event33",
                "evar1": "3p_redirection_return",
                "evar2": "stp_peronal_details_demog",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_26": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49"],
                "Action description 2": "when screen gets loaded to submit the city details",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_peronal_details_city",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "SSL created (City not confirmed)",
                "evar45": "Residence City required"
        },
        "tracking_27": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49"],
                "Action description 2": "when user click on continue button to confirm his city",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_peronal_details_city",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_27.1": {
            "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49"],
            "Action description 2": "when information is submitted and next screen gets loaded",
            "Event Name": "event19",
            "evar1": "form_confirmation",
            "evar2": "stp_peronal_details_city",
            "evar3": "success",
            "evar4": "stp",
            "evar8": 'website',
            "evar28": "CITY_000",
            "evar29": "City Saved"
        },
        "tracking_27.1_error": {
            "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49"],
            "Action description 2": "when information is submitted and next screen gets loaded",
            "Event Name": "event15",
            "evar1": "form_error",
            "evar2": "stp_peronal_details_city",
            "evar3": "failure",
            "evar4": "stp",
            "evar8": 'website',
            "evar28": "CITY_999",
            "evar29": "ETECH"
        },
        "tracking_28": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41"],
                "Action description 2": "When user clicks on view benifits button on stp landing page",
                "Event Name": "click_link",
                "evar1": "click_link",
                "evar2": "view_benifits",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_29": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when screen gets loaded to submit the pan and dob",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_peronal_details_pan_dob",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "Lead Enrichment 1",
                "evar45": "PAN and DOB required"
        },
        "tracking_30": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when user click on confirm to submit the pan and dob",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_peronal_details_pan_dob",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_31": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when  nsdl call gets initiated",//"When demog call gets initiated",
                "Event Name": "event32",
                "evar1": "3p_redirection_initiate",
                "evar2": "stp_peronal_details_nsdl",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_32": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar46", "evar47"],
                "Action description 2": "When response from the nsdl call is received",//"When response from the demog call is received",
                "Event Name": "event33",
                "evar1": "3p_redirection_return",
                "evar2": "stp_peronal_details_nsdl",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_33": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49"],
                "Action description 2": "when this information gets submitted",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_peronal_details_pan_dob",
                "evar3": "success",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "PD_000/PD_001/PD_002",
        },
        "tracking_33_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49"],
                "Action description 2": "when this information gets submitted",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_peronal_details_pan_dob",
                "evar3": "failure",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "PD_000/PD_001/PD_002",
        },
        "tracking_34": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "if user click on edit button to edit the information",
                "Event Name": "event17",
                "evar1": "form_edit",
                "evar2": "stp_peronal_details",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_35": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when screen gets loaded to submit mothers name and email",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_peronal_details_email_mother_name",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "Lead Enrichment 2",
                "evar45": "Mother name and FFN or Referral code if applicable required"
        },
        "tracking_36": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when user click on confirm to submit the mothers name and email",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_peronal_details_email_mother_name",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_37": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when this information gets submitted",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_peronal_details_email_mother_name",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_38": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "if user click on edit button to edit the information",
                "Event Name": "event17",
                "evar1": "form_edit",
                "evar2": "stp_peronal_details",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_39": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when user click to submit all the personal details",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_peronal_details",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_40": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when user's personal information is submitted",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_peronal_details",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_41": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar50"],
                "Action description 2": "when user's personal information is submitted",
                "Event Name": "event34",
                "evar1": "journey_milestone",
                "evar2": "stp",
                "evar3": "personal_details",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_42": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When first screen gets loaded to submit the professional details",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_professional_details",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "Lead Completion 1",
                "evar45": "Occupation type Company name and designation required"
        },
        "tracking_43": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when screen gets loaded to submit occupation",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_professional_details_occupation",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "Lead Completion 1",
                "evar45": "Occupation type Company name and designation required"
        },
        "tracking_44": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when user click on confirm to submit the occupation",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_professional_details_occupation",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_45": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when this information gets submitted",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_professional_details_occupation",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "SD1_000/SD1_101/SD1_102/SD1_105",
                "evar29": "CC Failed/SD1_Decline/SD1_Approve/If CKYC data not found/Invalid Referral Code/ETECH Case"
        },
        "tracking_45_Error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar26", "evar27", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when this information gets submitted",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_professional_details_occupation",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "",
                "evar29": ""
        },
        "tracking_127": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when screen gets loaded to submit salaried details",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_professional_details_salaried",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "Lead Completion 1",
                "evar45": "Occupation type Company name and designation required"
        },
        "tracking_128": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when user click on confirm to submit the salaried details",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_professional_details_salaried",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_129": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when this information gets submitted",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_professional_details_salaried",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "SD1_000/SD1_101/SD1_102/SD1_105"
        },
        "tracking_130": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when screen gets loaded to submit self employed details",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_professional_details_self_employed",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "Lead Completion 1",
                "evar45": "Occupation type Company name and designation required"
        },
        "tracking_131": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when user click on confirm to submit the self employed details",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_professional_details_self_employed",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_132": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when this information gets submitted",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_professional_details_self_employed",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "SD1_000/SD1_101/SD1_102/SD1_105"
        },
        "tracking_46": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41"],
                "Action description 2": "when screen gets loaded to submit company name and designation",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_professional_details_company_designation",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_47": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41"],
                "Action description 2": "when user click on confirm to submit the company name and designation",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_professional_details_company_designation",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_48": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar32", "evar33", "evar39", "evar40", "evar41"],
                "Action description 2": "when this information gets submitted",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_professional_details_company_designation",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "SD1_000/SD1_101/SD1_102/SD1_105",
        },
        "tracking_49": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41"],
                "Action description 2": "when screen gets loaded to submit retirement details",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_professional_details_retired",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_50": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41"],
                "Action description 2": "when user click on confirm to submit the retirement details",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_professional_details_retired",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_51": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41"],
                "Action description 2": "when this information gets submitted",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_professional_details_retired",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_52": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when screen gets loaded to submit work location address",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_professional_details_work_address",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "Lead Completion 2",
                "evar45": "Employer address required"
        },
        "tracking_53": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar46", "evar47"],
                "Action description 2": "when user click on confirm to submit the work location address",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_professional_details_work_address",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_54": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when this information gets submitted",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_professional_details_work_address",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "SD1_000/SD1_101/SD1_102/SD1_105",
        },
        "tracking_55": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when screen gets loaded to submit new work location address",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_professional_details_add_work_address",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "Lead Completion 2",
                "evar45": "Employer address required"
        },
        "tracking_56": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar46", "evar47"],
                "Action description 2": "when user click on confirm to submit the new work location address",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_professional_details_add_work_address",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_57": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when this information gets submitted",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_professional_details_add_work_address",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "SD1_000/SD1_101/SD1_102/SD1_105",
        },
        "tracking_58": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar43", "evar46", "evar47"],
                "Action description 2": "When user submit all the professional details",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_professional_details",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_59": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49"],
                "Action description 2": "when this information gets submitted",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_professional_details",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "SD1_000/SD1_101/SD1_102/SD1_105",
        },
        "tracking_59_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49"],
                "Action description 2": "when this information gets submitted",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_professional_details",
                "evar3": "failure",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "SD1_000/SD1_101/SD1_102/SD1_105",
        },
        "tracking_60": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when professional information gets submitted",
                "Event Name": "event34",
                "evar1": "journey_milestone",
                "evar2": "stp",
                "evar3": "professional_details",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_61": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when professional information gets submitted",
                "Event Name": "event34",
                "evar1": "journey_milestone",
                "evar2": "stp",
                "evar3": "application_created",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_62": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar34", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user load the kyc details form",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_kyc_details",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "Lead enhancement 1",
                "evar45": "Current Residence address required"
        },
        "tracking_63": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user load the kyc details form",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_kyc_details_select_address",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "Lead enhancement 1",
                "evar45": "Current Residence address required"
        },
        "tracking_64": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar34", "evar35", "evar39", "evar40", "evar41", "evar42", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user click on continue to select the address",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_kyc_details_select_address",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_65": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when address is selected and user moved to confrim the address",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_kyc_details_select_address",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "SD2_000/SD2_001/SD2_002/SD2_100/SD2_105",
                "evar29": "SD2_Approve_Y_AppliedCardType/SD2_Approve_Y_Downsell_CardType/SD2_STP_N/SD2_Decline/ETECH Case"
        },
        "tracking_65_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when address is selected and user moved to confrim the address",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_kyc_details_select_address",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "SD2_000/SD2_001/SD2_002/SD2_100/SD2_105",
        },
        "tracking_66": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user choose to get the address details from digilocker",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_kyc_details_digilocker_aadhar",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "Lead enhancement 1",
                "evar45": " Current Residence address required"
        },
        "tracking_67": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when user submit the aadharcard details and click submit",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_kyc_details_digilocker_aadhar",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_68": {
                "dynamicValues": ["evar5", "evar6", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when adhar is submitted and user is moved to otp screen",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_kyc_details_digilocker_aadhar",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_69": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when otp screen gets loaded",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_kyc_details_digilocker_otp",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "Lead enhancement 1",
                "evar45": "Current Residence address required"
        },
        "tracking_70": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar31", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when user submit the otp",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_kyc_details_digilocker_otp",
                "evar4": "stp",
                "evar8": 'website',
                "evar31": "Y"
        },
        "tracking_71": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when otp confrimation is done and user moved to digilocker access screen",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_kyc_details_digilocker_otp",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_72": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when user landed to access confirm screen",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_kyc_details_digilocker_access",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "Lead enhancement 1",
                "evar45": "Current Residence address required"
        },
        "tracking_73": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "user allow access",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_kyc_details_digilocker_access",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_74": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "user deny access",
                "Event Name": "event11",
                "evar1": "form_abandonment",
                "evar2": "stp_kyc_details_digilocker_access",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_75": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user allowed the access and moved to next screen",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_kyc_details_digilocker_access",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_76": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar34", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when confirm address screen gets loaded",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_kyc_details_confirm_address",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "Lead enhancement 1",
                "evar45": "Current Residence address required"
        },
        "tracking_77": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar34", "evar35", "evar39", "evar40", "evar41", "evar42", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user click on submit to confirm the residential address",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_kyc_details_confirm_address",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_78": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar34", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when address isconfirmed and user moved to next screen",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_kyc_details_confirm_address",
                "evar3": "success",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "SD2_000/SD2_001/SD2_002/SD2_100/SD2_105/SD2_103",

        },
        "tracking_78_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar34", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when address isconfirmed and user moved to next screen",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_kyc_details_confirm_address",
                "evar3": "failure",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "SD2_000/SD2_001/SD2_002/SD2_100/SD2_105",

        },
        "tracking_79": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar34", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user select to add the address manually",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_kyc_details_add_address",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "Lead enhancement 1",
                "evar45": "Current Residence address required"
        },
        "tracking_80": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar34", "evar35", "evar39", "evar40", "evar41", "evar42", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user submit the address details",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_kyc_details_add_address",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_81": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar34", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49" , "evar50"],
                "Action description 2": "when address details are submitted and user moved to next screen",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_kyc_details_add_address",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "SD2_000/SD2_001/SD2_002/SD2_100/SD2_105",
        },
        "tracking_81_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar34", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when address details are submitted and user moved to next screen",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_kyc_details_add_address",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "SD2_000/SD2_001/SD2_002/SD2_100/SD2_105",
        },
        "tracking_133": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar34", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user asked to provide gender details",//"when user select to add the address manually",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_kyc_details_gender",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "Lead enhancement 2",
                "evar45": "Gender required"
        },
        "tracking_134": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33",  "evar34", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user select the gender details",//"when user submit the address details",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_kyc_details_gender",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_135": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar34", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user click on confirm after selecting gender details",//"when address details are submitted and user moved to next screen",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_kyc_details_gender",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "SD2_000/SD2_001/SD2_002/SD2_100/SD2_105",
        },
        "tracking_135_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar34", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user click on confirm after selecting gender details",//"when address details are submitted and user moved to next screen",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_kyc_details_gender",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "SD2_000/SD2_001/SD2_002/SD2_100/SD2_105",
        },
        "tracking_82": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar34", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when finally all the kyc details are submitted",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_kyc_details",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_83": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar34", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when kyc is done and user moved to next screen",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_kyc_details",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_83_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar34", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when kyc is done and user moved to next screen",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_kyc_details",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_84": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when address details are submitted and user moved to next screen",
                "Event Name": "event34",
                "evar1": "journey_milestone",
                "evar2": "stp",
                "evar3": "address_confirmation",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_85": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when address details are submitted and user moved to next screen",
                "Event Name": "event34",
                "evar1": "journey_milestone",
                "evar2": "stp",
                "evar3": "kyc_completed",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_86": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user landed on screen to see single card option",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_select_desired_card",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "Card type confirmation",
                "evar45": "Card Confirmation required"
        },
        "tracking_87": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar17", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49" , "evar50"],
                "Action description 2": "when user select any card and continue",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_select_desired_card",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_88": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar17", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user move to next screen",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_select_desired_card",
                "evar3": "success",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_86.1": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41",  "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user landed on screen to see multiple card type options",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_select_downsell_card",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "Card type confirmation",
                "evar45": "Card Confirmation required"
        },
        "tracking_87.1": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar17", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user select any card and continue",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_select_downsell_card",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_88.1": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar17", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar39", "evar40", "evar41", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user move to next screen",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_select_downsell_card",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_88.1_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar17", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar39", "evar40", "evar41", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user move to next screen",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_select_downsell_card",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_89": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user gets landed on screen to upload the photo",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_photo_match",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "KYC completion - Photo",
                "evar45": "Photo click or upload required"
        },
        "tracking_90": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user click submit to upload the photo",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_photo_match",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_91": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user's photo is uploaded",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_photo_match",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "PM_000/PM_001/PM_002/PM_101/PM_102/PM_103/PM_104/PM_105/PM_106/PM_107"
        },
        "tracking_91_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user's photo is uploaded",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_photo_match",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "PM_000/PM_001/PM_002/PM_101/PM_102/PM_103/PM_104/PM_105/PM_106/PM_107"
        },
        "tracking_92": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user's photo is uploaded",
                "Event Name": "event34",
                "evar1": "journey_milestone",
                "evar2": "stp",
                "evar3": "photo_match",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_93": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User sellects Start with step 1 for penny drop",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_bank_verification_credit",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "KYC due diligence - Penny drop 1",
                "evar45": "Penny drop  Account number and IFSC code required"
        },
        "tracking_94": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User submits account number and ifsc",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_bank_verification_credit",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_95": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User is moved to the next page",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_bank_verification_credit",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "PD_Cr_000/PD_Cr_001/PD_Cr_002/PD_Cr_003/PD_Cr_004/PD_Cr_103",
        },
        "tracking_95_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User is moved to the next page",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_bank_verification_credit",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "PD_Cr_000/PD_Cr_001/PD_Cr_002/PD_Cr_003/PD_Cr_004/PD_Cr_103",
        },
        "tracking_96": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User click on find to search bank details via IFSC code",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_bank_verification_find_ifsc",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "KYC due diligence - Penny drop 1",
                "evar45": "Penny drop  Account number and IFSC code required"
        },
        "tracking_97": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User selects bank branches from the search list",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_bank_verification_find_ifsc",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_98": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "user is back to the accounts page",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_bank_verification_find_ifsc",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_99": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User clicks on Continue after filing Bank details",
                "Event Name": "event34",
                "evar1": "journey_milestone",
                "evar2": "stp",
                "evar3": "bank_verification_credit_done",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_100": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User sellect Net Banking",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_bank_verification_debit_netbanking",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "KYC due diligence - Penny drop 2",
                "evar45": "Penny drop  Applicant to give Rs 2 back"
        },
        "tracking_101": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User provide the Net banking details (Bill desk Page)",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_bank_verification_debit_netbanking",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_102": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User sellect Net Banking",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_bank_verification_debit_netbanking",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_102_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User sellect Net Banking",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_bank_verification_debit_netbanking",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_103": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User Sellects UPI",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_bank_verification_debit_upi",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "KYC due diligence - Penny drop 2",
                "evar45": "Penny drop  Applicant to give Rs 2 back"
        },
        "tracking_104": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User enter VPA and clicks on make payment",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_bank_verification_debit_upi",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_105": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User complete the Payment of 2 Rs.",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_bank_verification_debit_upi",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_105_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User complete the Payment of 2 Rs.",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_bank_verification_debit_upi",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_106": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23",  "evar28", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "Debit Verification Journey Completed",
                "Event Name": "event34",
                "evar1": "journey_milestone",
                "evar2": "stp",
                "evar3": "bank_verification_debit_done",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_107": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User View his final card and clicks on continue",
                "Event Name": "event3",
                "evar1": "login_2f_intent",
                "evar2": "stp_form",
                "evar3": "otp",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "T&C agreement 1",
                "evar45": "Terms and conditions agreement required"
        },
        "tracking_107.1": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user lands on MITC screen",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_mitc",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "T&C agreement 1",
                "evar45": "Terms and conditions agreement required"
        },
        "tracking_107.2": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When User clicks on view benefits",
                "Event Name": "event7",
                "evar1": "form_submit",
                "evar2": "stp_mitc_view_benefits",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "T&C agreement 1",
                "evar45": "Terms and conditions agreement required"
        },
        "tracking_107.3": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When userclicks on checkbox and continue on MITC screen",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_mitc",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "T&C agreement 1",
                "evar45": "Terms and conditions agreement required"
        },
        "tracking_108": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User submits otp",
                "Event Name": "event4",
                "evar1": "login_2f_auth",
                "evar2": "stp_form",
                "evar3": "otp:valid/invalid/expired",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "OTP validation",
                "evar45": "OTP validation required"
        },
        "tracking_109": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when complete stp form is submitted",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_form",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_110": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when form is submitted and user gets confirmation for Ecard Generation",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_form",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_110_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when form is submitted and user gets confirmation for Ecard Generation",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_form",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_111": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "STP Form Submission Journey Completed",
                "Event Name": "event34",
                "evar1": "journey_milestone",
                "evar2": "stp",
                "evar3": "form_submitted",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_112": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User clicks for CVV",
                "Event Name": "event28",
                "evar1": "click_link",
                "evar2": "stp_view_cvv",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_113": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User clicks on Set online preference",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_set_online_preference",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "Card issuance",
                "evar45": "Card issued to customer"
        },
        "tracking_114": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User provide the OTP to set the preferences",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_set_online_preference",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_115": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User is moved to the next page",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_set_online_preference",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_115_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User is moved to the next page",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_set_online_preference",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_116": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23",  "evar28", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "STP Journey Completed",
                "Event Name": "event34",
                "evar1": "journey_milestone",
                "evar2": "stp",
                "evar3": "journey_completed",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_117": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when form gets loaded to provide additional details to earn Reward points",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_additional_details",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_118": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "User click on submit to provide additional details",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_additional_details",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_119": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "User is moved to the next page",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_additional_details",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_120": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User Clicks on Browse or drag the to upload Pan Card due to the name mismatch or photo mismatch \r\nUser clicks on camera to click the photo and upload",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_pancard",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "Additional Doc",
                "evar45": "PAN Card front and back copy required"
        },
        "tracking_121": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User upload pan card",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_pancard",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_122": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User clicks on Submit Pan Card",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_pancard",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_122_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User clicks on Submit Pan Card",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_pancard",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_123": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when track application form loads",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "track_status",
                "evar3": "stp_application",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_124": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "User clicks on Track your application",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "track_status",
                "evar3": "stp_application",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_125": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when we get the response of track application",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "track_status",
                "evar3": "stp_application",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_126": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User leave the journey after OTP confirmation\r\nUser leave the journey after City confirmation\r\nUser leave the journey after PAN & DOB confirmation\r\nUser leave the journey after MMN & Email confirmation\r\nUser leave the journey after providing Occupation Details confirmation\r\nUser leave the journey after providing Company Address\r\nUser leave the journey after providing Company Address Manually\r\nUser leave the journey after confirming Address\r\nUser dropp off from the Manually submitted screen\r\nUser leaves the journey after viewing the virtual card\r\nUser leaves the journey after uploading the photo",
                "Event Name": "event35",
                "evar1": "journey_abandon",
                "evar2": "stp",
                "evar3": "User action(Enter options/last stage/tasks)\r\ni.e. OTP confirmation/\r\nplan according to retargeting",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_136": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when form is submitted and user gets confirmation for MITC",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_mitc",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_136_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when form is submitted and user gets confirmation for MITC",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_mitc",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_137": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user lands on Pending for Verification screen when user goes to FTE queue  due to PAN verification",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_pending_pan_verification",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_137_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user lands on Pending for Verification screen when user goes to FTE queue  due to PAN verification",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_pending_pan_verification",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_138": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "Specific to YONO - CAD screen gets loaded for address confirmation",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_banca_confrim_address",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "Lead enhancement 1",
                "evar45": "Current Residence address required"
        },
        "tracking_139": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "Specific to YONO - when user submit  the confirmed address at CAD screen",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_banca_confrim_address",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_140": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "Specific to YONO - when user confirm the address at CAD screen",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_banca_confrim_address",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_140_error": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar28", "evar29", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "Specific to YONO - when user confirm the address at CAD screen",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_banca_confrim_address",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_141": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14","evar17", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar35","evar36", "evar39", "evar40", "evar41","evar42", "evar43", "evar44", "evar45", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When screen gets loaded to select the KYC Mode",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_kyc_mode_selection",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_142": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14","evar17", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar35","evar36","evar37", "evar39", "evar40", "evar41", "evar42","evar43", "evar44", "evar45", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user selects the KYC mode",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_retry_vkyc_url_fetch",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_143": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14","evar17", "evar18", "evar19", "evar20", "evar22","evar23","evar25","evar26","evar27", "evar32", "evar33", "evar35","evar36","evar37", "evar39", "evar40", "evar41", "evar42","evar43", "evar44", "evar45", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When the url fetch call confirmed",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_vkyc_adhar_mode_selection_url_fetched",
                "evar3": "success",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_143_error": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14","evar17", "evar18", "evar19", "evar20", "evar22","evar23","evar25","evar26","evar27", "evar32", "evar33", "evar35","evar36","evar37", "evar39", "evar40", "evar41", "evar42","evar43", "evar44", "evar45", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When the url fetch call confirmed",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_vkyc_adhar_mode_selection_url_fetched",
                "evar3": "failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_144": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14", "evar17", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar35","evar36","evar39", "evar40", "evar41", "evar42","evar43", "evar44", "evar45", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When hyperverge call gets initiated",
                "Event Name": "event32",
                "evar1": "3p_redirection_initiate",
                "evar2": "stp_vkyc_hyperverge",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_145": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar11", "evar12", "evar13", "evar14","evar17", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar35","evar36", "evar39", "evar40", "evar41", "evar42","evar43", "evar44", "evar45", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user returns back to Sprint from Hyperverge",
                "Event Name": "event33",
                "evar1": "3p_redirection_return",
                "evar2": "stp_vkyc_hyperverge",
                "evar3": "approved/declined/incomplete/locationnoncompliant/noslots",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_146": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14","evar17", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar35","evar36", "evar39", "evar40", "evar41", "evar42","evar43", "evar44", "evar45", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user is shown the WIP screen with FTE audit pending message",
                "Event Name": "event20",
                "evar1": "page_load",
                "evar2": "stp_vkyc_approved",
                "evar4": "stp",
                "evar8": 'website',
        },
       "tracking_147": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14", "evar17", "evar21", "evar24",  "evar40", "evar41", "evar46", "evar47", "evar48", "evar49"],
                "Action description 2": "When user clicks on \"Change Network\" button on stp landing page",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_change_card_network",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_148": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14","evar17", "evar21", "evar24", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49"],
                "Action description 2": "When user clicks on \"proceed\" button on pop-up of change card confirmation",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_change_card_network",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_149": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14", "evar17", "evar18", "evar19", "evar20", "evar21",  "evar22" , "evar23", "evar24", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user landed on screen to see multiple card type options",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_select_downsell_card_network",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_150": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14","evar17", "evar18", "evar19", "evar20", "evar21",  "evar22" ,"evar23", "evar24", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user select any card and continue",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_select_downsell_card_network",
                "evar4": "stp",
                "evar8": 'website',
        },
        /***** Telco Started ******/
        "tracking_151": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14","evar17", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar24", "evar25", "evar26", "evar27", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when user move to next screen",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_select_downsell_card_network",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_151_error": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14","evar17", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar24", "evar25","evar26", "evar27", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user move to next screen",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_select_downsell_card_network",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
	    "tracking_152": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar25", "evar26", "evar27", "evar28", "evar29", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When Send Telco OTP",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_details_telco_send_otp",
                "evar3": "success",
                "evar4": "stp",
                "evar8": 'website',
        },  
        "tracking_152_error": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar25", "evar26", "evar27", "evar28", "evar29", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When Send Telco OTP",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_details_telco_send_otp",
                "evar3": "failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_153": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar25", "evar26", "evar27", "evar28", "evar29", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User clicks on telco 'Submit' to verify otp",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_details_telco_verify_otp",
                "evar3": "success",
                "evar4": "stp",
                "evar8": 'website',
        },  
        "tracking_153_error": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar25", "evar26", "evar27", "evar28", "evar29", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User clicks on telco 'Submit' to verify otp",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_details_telco_verify_otp",
                "evar3": "failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_154": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when Telco otp input screen gets loaded",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_details_telco_verify_otp",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_155": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar25", "evar26", "evar27", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User clicks on telco 'Submit' to verify otp",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_details_telco_verify_otp",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_156": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar25", "evar26", "evar27", "evar31", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user clicks on telco 'Resend OTP' to revalidate",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_details_telco_resend_otp",
                "evar4": "stp",
                "evar8": 'website',
                "evar31": "N"
        },
        "tracking_157": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar25", "evar26", "evar27", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user click on 'Skip' button on Telco OTP page last filled application ",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_application_with_telco_skip",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_158": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar25", "evar26", "evar27", "evar28", "evar29", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user clicks on telco 'Resend OTP' to revalidate",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_details_telco_resend_otp",
                "evar3": "success",
                "evar4": "stp",
                "evar8": 'website',
        },  
        "tracking_158_error": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar25", "evar26", "evar27", "evar28", "evar29", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user clicks on telco 'Resend OTP' to revalidate",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_details_telco_resend_otp",
                "evar3": "failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_159": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar27", "evar28", "evar29", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user click on 'Skip' button on Telco OTP page last filled application",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_application_with_telco_skip",
                "evar3": "success",
                "evar4": "stp",
                "evar8": 'website',
        },  
        "tracking_159_error": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar27", "evar28", "evar29", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user click on 'Skip' button on Telco OTP page last filled application",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_application_with_telco_skip",
                "evar3": "failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_160": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar25", "evar26", "evar27", "evar28", "evar29", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When Telco is auto Skipped",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_application_with_telco_auto_skip",
                "evar3": "success",
                "evar4": "stp",
                "evar8": 'website',
        },  
        "tracking_160_error": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar25", "evar26", "evar27", "evar28", "evar29", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When Telco is auto Skipped",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_application_with_telco_auto_skip",
                "evar3": "failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_161": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar11", "evar12", "evar14", "evar17", "evar18", "evar19", "evar20", "evar21", "evar22", "evar23", "evar24", "evar25", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when telco otp verification are completed and user moved to next screen",
                "Event Name": "event34",
                "evar1": "journey_milestone",
                "evar2": "stp",
                "evar3": "telco_completed",
                "evar4": "stp",
                "evar8": 'website',
        },   
        "tracking_162": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14","evar17", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar35","evar36", "evar39", "evar40", "evar41", "evar42","evar43", "evar44", "evar45", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user is shown the WIP when Telco verify give STP N",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "telco_approved_stpn_wip_screen",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_163": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14","evar17", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar35","evar36", "evar39", "evar40", "evar41", "evar42","evar43", "evar44", "evar45", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When track page loaded in telco",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "telco_tarck_page",
                "evar4": "stp",
                "evar8": 'website',
        },      
        "tracking_164": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar25", "evar26", "evar27", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user click on 'Send Otp' from Telco Screen in Track Journey",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_application_with_track_telco_send_otp",
                "evar4": "stp",
                "evar8": 'website',
        },
        /***** Telco Ended ******/
        //Account Aggregator events
        "tracking_165": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar25" , "evar28" , "evar29" , "evar32", "evar33", "evar35", "evar36",  "evar39", "evar40", "evar41",  "evar42", "evar43", "evar46", "evar47" , "evar48", "evar49", "evar50"],
                "Action description 2": "When user lands on STP Income Surrogate form",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "",
                "evar4": "stp",
                "evar8": 'website',
        },
       /* ,
        "tracking_166": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When user opts for a Surrogate",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "",
                "evar4": "stp",
                "evar8": 'website',
        },*/
        "tracking_166": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When user opts for a Surrogate AA/GST/EPFO",
                "Event Name": "event23",
                "evar1": "click_link",
                "evar2": "",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_167": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14","evar17", "evar18", "evar19", "evar20", "evar21",  "evar22" ,"evar23", "evar24", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user clicks on 'Continue' button after selecting a surrogate option",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_168": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14","evar17", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar24", "evar25", "evar26", "evar27", "evar32", "evar33", "evar35", "evar36", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user clicks on 'Continue' button after selecting surrogate option",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_168_error": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14","evar17", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar24", "evar25","evar26", "evar27", "evar32", "evar33", "evar35", "evar36", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user clicks on 'Continue' button after selecting surrogate option",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_169": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar35", "evar36", "evar39", "evar40", "evar41", "evar42", "evar43", "evar44", "evar45", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When surrogate 3rd party redirection gets initiated",
                "Event Name": "event32",
                "evar1": "3p_redirection_initiate",
                "evar2": "",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_170": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar35", "evar36", "evar39", "evar40", "evar41", "evar42", "evar43", "evar44", "evar45", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user returns back to Sprint from surrogate 3rd party",
                "Event Name": "event33",
                "evar1": "3p_redirection_return",
                "evar2": "",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_171": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When user lands on Condtional MITC screen",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_mitc_conditional",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_172": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14","evar17", "evar18", "evar19", "evar20", "evar21",  "evar22" ,"evar23", "evar24", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When User clicks on view benefits of Condtional MITC screen",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_mitc_view_benefits_conditional",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_173": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14","evar17", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar24", "evar25", "evar26", "evar27", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When userclicks on checkbox and continue on Condtional MITC screen",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_mitc_conditional",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_173_error": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14","evar17", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar24", "evar25","evar26", "evar27", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When userclicks on checkbox and continue on Condtional MITC screen",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_mitc_conditional",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_174": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When screen gets loaded to Surrogate Status screen",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_income_surrogate_thankyou",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_175": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14","evar17", "evar18", "evar19", "evar20", "evar21",  "evar22" ,"evar23", "evar24", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user clicks on 'Continue' button of Surrogate Status Confirmation",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_income_surrogate_thankyou",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_176": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14","evar17", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar24", "evar25", "evar26", "evar27", "evar32", "evar33", "evar35", "evar36", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user clicks on 'Continue' button of Surrogate Status Confirmation",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_income_surrogate_thankyou",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_176_error": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14","evar17", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar24", "evar25","evar26", "evar27", "evar32", "evar33", "evar35", "evar36", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user clicks on 'Continue' button of Surrogate Status Confirmation",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_income_surrogate_thankyou",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        // EPFO Started
        "tracking_177": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar25", "evar26", "evar27", "evar28", "evar29", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When Send EPFO OTP",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_details_epfo_send_otp",
                "evar3": "success",
                "evar4": "stp",
                "evar8": 'website',
        },  
        "tracking_177_error": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar25", "evar26", "evar27", "evar28", "evar29", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When Send EPFO OTP",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_details_epfo_send_otp",
                "evar3": "failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_178": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when EPFO otp input screen gets loaded",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_details_epfo_verify_otp",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_179": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar25", "evar26", "evar27", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User clicks on EPFO 'Submit' to verify otp",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_details_epfo_verify_otp",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_180": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar25", "evar26", "evar27", "evar28", "evar29", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User clicks on EPFO 'Submit' to verify otp",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_details_epfo_verify_otp",
                "evar3": "success",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_180_error": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar25", "evar26", "evar27", "evar28", "evar29", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "User clicks on EPFO 'Submit' to verify otp",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_details_epfo_verify_otp",
                "evar3": "failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_181": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar25", "evar26", "evar27", "evar31", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user clicks on EPFO 'Resend OTP' to revalidate",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_details_epfo_resend_otp",
                "evar4": "stp",
                "evar8": 'website',
                "evar31": "N"
        },
        "tracking_182": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar25", "evar26", "evar27", "evar28", "evar29", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user clicks on EPFO 'Resend OTP' to revalidate",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_details_epfo_resend_otp",
                "evar3": "success",
                "evar4": "stp",
                "evar8": 'website',
        },  
        "tracking_182_error": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar21",  "evar22", "evar23", "evar25", "evar26", "evar27", "evar28", "evar29", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user clicks on EPFO 'Resend OTP' to revalidate",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_details_epfo_resend_otp",
                "evar3": "failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_183": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user click on 'Back' button on EPFO OTP page",
                "Event Name": "event23",
                "evar1": "click_link",
                "evar2": "stp_application_with_epfo_back",
                "evar4": "stp",
                "evar8": 'website',
        }, 
        // EPFO ended  
        "tracking_184": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when screen gets loaded to submit mothers name and email",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_change_card_KrisFlyer",
                "evar4": "stp",
                "evar8": 'website',
                "evar44": "Lead Enrichment 2",
                "evar45": "Mother name and FFN or Referral code if applicable required"
        },
        "tracking_185": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar15", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when user click on confirm to submit the mothers name and email",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_change_card_KrisFlyer",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_186": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar15", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when this information gets submitted",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_change_card_KrisFlyer",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },  
        "tracking_186_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar15", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "when this information gets submitted",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_change_card_KrisFlyer",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_187": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar35", "evar36", "evar39", "evar40", "evar41", "evar42", "evar43", "evar44", "evar45", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "when DigiLocker gets initiated",
                "Event Name": "event32",
                "evar1": "3p_redirection_initiate",
                "evar2": "stp_kyc_details_digilocker_access",
                "evar4": "stp",
                "evar8": 'website',
        },
        // KYC Start
        /*****ekyc Option page start ***/
        "tracking_188": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When ekyc option screen gets loaded to select adhar mode selection",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_ekyc_adhar_mode_selection",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_189": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar15", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When user click on continue to adhar mode selection",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_ekyc_adhar_mode_selection",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_190": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar35", "evar36", "evar39", "evar40", "evar41", "evar42", "evar43", "evar44", "evar45", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user is reditecing to get ekyc portal",
                "Event Name": "event32",
                "evar1": "3p_redirection_initiate",
                "evar2": "",
                "evar4": "stp",
                "evar8": 'website',
        },
        /****ekyc Option page end****/
        /****ekyc status page start****/
        "tracking_191": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user is returned back from ekyc portal with success", // reekyc 
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_ekyc_adhar_mode_opt_status",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_192": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar15", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When user is returned back from ekyc portal with success",//  rekyc 
                "Event Name": "event19",
                "evar1": "form_confirmation",  
                "evar2": "stp_ekyc_adhar_mode_opt_status",
                "evar3": "success",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_192_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar15", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When user is returned back from ekyc portal with success",//  rekyc 
                "Event Name": "event19",
                "evar1": "form_error",  
                "evar2": "stp_ekyc_adhar_mode_opt_status",
                "evar3": "failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        /****ekyc status page start****/
        /****rekyc continue page start****/
        "tracking_193": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When re-kyc loader screen gets loaded to redirect to ekyc portal",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_rekyc_adhar_mode_selection",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_194": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar15", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When user is given intemation to re-kyc start from re-kyc loader page",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_rekyc_adhar_mode_selection",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_194_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar15", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When user is given intemation to re-kyc start from re-kyc loader page",
                "Event Name": "event19",
                "evar1": "form_error",
                "evar2": "stp_rekyc_adhar_mode_selection",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_195": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar15", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When off hours API confirmed that user has come within working hours",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_vkyc_adhar_mode_selection_off_hours",
                "evar3": "success",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_195_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar15", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When off hours API confirmed that user has come within working hours",
                "Event Name": "event19",
                "evar1": "form_error",
                "evar2": "stp_vkyc_adhar_mode_selection_off_hours",
                "evar3": "failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        /*****Ekyc Portal Return*****/
        "tracking_196": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar11", "evar12", "evar13", "evar14","evar17", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar35","evar36", "evar39", "evar40", "evar41", "evar42","evar43", "evar44", "evar45", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user is returned back from ekyc portal",
                "Event Name": "event33",
                "evar1": "3p_redirection_return",
                "evar2": "",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        /******vkyc loader  page start************ */
        "tracking_197": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When vkyc loader screen gets loaded",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_vkyc_adhar_mode_selection",
                "evar4": "stp",
                "evar8": 'website',
        },
        /******vkyc loader  page end************ */
       /*********Banka Loader Screen********** */
       "tracking_198": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When ekyc Banca screen gets loaded",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_ekyc_banca",
                "evar4": "stp",
                "evar8": 'website',
        },
        // KYC Ends
        // manually (takes longer) Start
        "tracking_201": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar35", "evar39", "evar40", "evar41", "evar42", "evar43", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user click on \"Enter address manually (takes longer)\" link to enter address manually",
                "Event Name": "event23",
                "evar1": "click_link",
                "evar2": "stp_kyc_details_manual_access",
                "evar4": "stp",
                "evar8": 'website',
        "tracking_189": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar15", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When user click on continue to adhar mode selection",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_ekyc_adhar_mode_selection",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_190": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar35", "evar36", "evar39", "evar40", "evar41", "evar42", "evar43", "evar44", "evar45", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user is reditecing to get ekyc portal",
                "Event Name": "event32",
                "evar1": "3p_redirection_initiate",
                "evar2": "",
                "evar4": "stp",
                "evar8": 'website',
        },
        /****ekyc Option page end****/
        /****ekyc status page start****/
        "tracking_191": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user is returned back from ekyc portal with success", // reekyc 
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_ekyc_adhar_mode_opt_status",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_192": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar15", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When user is returned back from ekyc portal with success",//  rekyc 
                "Event Name": "event19",
                "evar1": "form_confirmation",  
                "evar2": "stp_ekyc_adhar_mode_opt_status",
                "evar3": "success",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_192_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar15", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When user is returned back from ekyc portal with success",//  rekyc 
                "Event Name": "event19",
                "evar1": "form_confirmation",  
                "evar2": "stp_ekyc_adhar_mode_opt_status",
                "evar3": "failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        /****ekyc status page start****/
        /****rekyc continue page start****/
        "tracking_193": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When re-kyc loader screen gets loaded to redirect to ekyc portal",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_rekyc_adhar_mode_selection",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_194": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar15", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When user is given intemation to re-kyc start from re-kyc loader page",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_rekyc_adhar_mode_selection",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_194_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar15", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When user is given intemation to re-kyc start from re-kyc loader page",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_rekyc_adhar_mode_selection",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_195": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar15", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When off hours API confirmed that user has come within working hours",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_vkyc_adhar_mode_selection_off_hours",
                "evar3": "success",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_195_error": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar15", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47"],
                "Action description 2": "When off hours API confirmed that user has come within working hours",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_vkyc_adhar_mode_selection_off_hours",
                "evar3": "failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        /*****Ekyc Portal Return*****/
        "tracking_196": {
                "dynamicValues": ["evar5", "evar7", "evar8", "evar11", "evar12", "evar13", "evar14","evar17", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar35","evar36", "evar39", "evar40", "evar41", "evar42","evar43", "evar44", "evar45", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When user is returned back from ekyc portal",
                "Event Name": "event33",
                "evar1": "3p_redirection_return",
                "evar2": "",
                "evar3": "success/failure",
                "evar4": "stp",
                "evar8": 'website',
        },
        /******vkyc loader  page start************ */
        "tracking_197": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When vkyc loader screen gets loaded",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_vkyc_adhar_mode_selection",
                "evar4": "stp",
                "evar8": 'website',
        },
        /******vkyc loader  page end************ */
       /*********Banka Loader Screen********** */
       "tracking_198": {
                "dynamicValues": ["evar5", "evar6", "evar7", "evar8", "evar9", "evar10", "evar11", "evar12", "evar13", "evar14", "evar18", "evar19", "evar20", "evar22", "evar23", "evar32", "evar33", "evar39", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49", "evar50"],
                "Action description 2": "When ekyc Banca screen gets loaded",
                "Event Name": "event7",
                "evar1": "form_load",
                "evar2": "stp_ekyc_banca",
                "evar4": "stp",
                "evar8": 'website',
        },
        // KYC Ends
        /* *****Indigo Event Ends************ */
       "tracking_199": {
                "dynamicValues": ["evar12", "evar13", "evar14", "evar15", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49"],
                "Action description 2": "When Indigo user clicks on confirm to submit after entering Email ID",
                "Event Name": "event18",
                "evar1": "form_submit",
                "evar2": "stp_fetch_indigo_ffn_by_email_mobile",
                "evar4": "stp",
                "evar8": 'website',
        },
        "tracking_200": {
                "dynamicValues": ["evar12", "evar13", "evar14", "evar15", "evar26", "evar27", "evar28", "evar29", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49"],
                "Action description 2": "when this information gets submitted",
                "Event Name": "event19",
                "evar1": "form_confirmation",
                "evar2": "stp_fetch_indigo_ffn_by_email_mobile",
                "evar3": "success",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "INDGO_000",
                "evar29": "EmailID_MobileNumber_Both_Exist_Indigo/EmailID_MobileNumber_Both_NotExist"
        },  
        "tracking_200_error": {
                "dynamicValues": ["evar12", "evar13", "evar14", "evar15", "evar26", "evar27", "evar28", "evar29", "evar40", "evar41", "evar46", "evar47", "evar48", "evar49"],
                "Action description 2": "when this information gets submitted",
                "Event Name": "event15",
                "evar1": "form_error",
                "evar2": "stp_fetch_indigo_ffn_by_email_mobile",
                "evar3": "failure",
                "evar4": "stp",
                "evar8": 'website',
                "evar28": "INDGO_101/INDGO_102/INDGO_104/INDGO_999",
                "evar29": "EmailID_MobileNumber_Both_ExistWith_Diff_Customer/MobileNumbers_Registered_With_Diff_EmailID/EmailID_Registered_With_Diff_MobileNumber"
        },
        /* *****Indigo Event End************ */
        }
        // manually (takes longer) END 
}

export default trackingObj;